import { plugin, defaultConfig } from '@formkit/vue';
import { en, nb } from '@formkit/i18n';
import { genesisIcons } from '@formkit/icons';
import { icons as nhstIcons, rootClasses as nhstRootClasses } from '@nhst/css/formkit-theme';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  nuxtApp.vueApp.use(
    plugin,
    defaultConfig({
      locales: { en, nb },
      locale: (runtimeConfig.public.language as string) || 'nb',
      config: {
        rootClasses: nhstRootClasses
      },
      icons: {
        ...genesisIcons,
        ...nhstIcons
      }
    })
  );
});
